const actions = { LOGOUT: 'LOGOUT', logout: () => ({ type: actions.LOGOUT }) };

export default actions;
